import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useMpSearchProfileId from 'src/reactiveVars/MpSearchProfileIdVar';
import MPSelect from 'src/shared/Tenders/MpSelect';

export const MPSearchGroup: FC = () => {
  const { t } = useTranslation();
  const [mpSearchGroupId, setMpSearchGroupId] = useMpSearchProfileId();

  return (
    <>
      <MPSelect
        selectedValue={mpSearchGroupId}
        updateSelectValue={setMpSearchGroupId}
        placeholder={t('Tenders.selectProfile')}
      />
    </>
  );
};

export default MPSearchGroup;
